/* ============
 * Stock Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './stockProduct';
import warehouseTrans from './warehouse';

export default class StockTransformer extends Transformer {

  static fetch(stock) {
    return {
      id: stock.id,
      warehouseId: stock.warehouse_id,
      total_qty: stock.total_qty,
      descriptions: stock.descriptions,
      code: stock.code,
      name: stock.name,
      createdAt: stock.created_at,
      products: stock.products !== undefined ? productTrans.fetchCollection(stock.products) : [],
      warehouse: stock.warehouse !== undefined ? warehouseTrans.fetch(stock.warehouse) : [],
      warehouseName: stock.warehouse_name,
      transactionDate: stock.transaction_date,
      status: stock.status,
    };
  }

  static send(stock) {
    return {
      warehouse_id: stock.warehouseId,
      name: stock.name,
      products: productTrans.sendCollection(stock.products),
      descriptions: stock.descriptions,
      transaction_date: stock.transactionDate,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/stock.js